// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__XKS4W","header":"Messages_header__1ZydM"};